import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import type { Product } from '../../types/product';
import { ProductCard } from './ProductCard';
type ProductSectionProps = {
  title: string;
  subtitle?: string;
  link?: {
    to: string;
    label: string;
  };
  products: Product[];
};
export function ProductSection({
  title,
  subtitle,
  link,
  products
}: ProductSectionProps) {
  return <section className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28" data-id="element-367" data-mp="37e31115mkrqz">
      <div className="mb-10 flex items-end justify-between gap-6" data-id="element-368" data-mp="3cburrruja7tl">
        <div data-id="element-369" data-mp="3ca1tp0xzkvx7">
          <h2 className="font-display text-4xl uppercase tracking-display text-ink sm:text-5xl" data-id="element-370" data-mp="2xevpmjigb76i">{title}</h2>
          {subtitle && <p className="mt-2 text-muted" data-id="element-371" data-mp="32dfashp80ext">{subtitle}</p>}
        </div>
        {link && <Link to={link.to} className="group hidden shrink-0 items-center gap-1.5 whitespace-nowrap text-sm font-medium text-ink sm:inline-flex" data-id="element-372" data-mp="1lzyjtxy1s3cg">
            {link.label}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" data-id="element-373" data-mp="1nob9ncfptzlh" />
          </Link>}
      </div>
      <ul className="grid grid-cols-2 gap-x-4 gap-y-10 lg:grid-cols-4 lg:gap-x-6" data-id="element-374" data-mp="1irktkp3wv402">
        {products.map(p => <li key={p.slug} data-id="element-375" data-mp="1wn50snaa1xrn">
            <ProductCard product={p} data-id="element-376" data-mp="1rpwt5gmr9c4n" />
          </li>)}
      </ul>
      {link && <Link to={link.to} className="mt-10 flex h-12 items-center justify-center rounded-full border border-ink text-sm font-medium sm:hidden" data-id="element-377" data-mp="26nfgqfnp5jai">
          {link.label}
        </Link>}
    </section>;
}